/**
 * Blank CI+PL template access (B1).
 *
 * The real BRITZMEDI form (`templates/_source/2604_Invoice_NEWCHAE_Mexico.xlsx`,
 * sheets INVOICE-US + PACKING LIST) is the basis. A one-time build step
 * (`scripts/build-template.ts`) clears the customer-specific cells and saves the
 * pixel-preserving blank `templates/ci-pl-template.xlsx`, then embeds those bytes
 * as base64 in `template-data.ts`. We embed (rather than read from disk / fetch)
 * so the merge engine stays a PURE module that runs identically in the browser
 * bundle, in Node, and in vitest — no `fs`, no network.
 *
 * "양식 변경 시 merge_map만 수정" (CONTRACT §4): cell coordinates live in
 * `merge-map.ts`, never hard-coded here.
 */

import { TEMPLATE_BASE64 } from "./template-data";
import {
  SHEET_NAME_INVOICE,
  SHEET_NAME_PACKING,
} from "./merge-map";

export const SHEET_INVOICE = SHEET_NAME_INVOICE;
export const SHEET_PACKING = SHEET_NAME_PACKING;

export const DISCLAIMER_KO =
  "본 도구는 사전정의 룰만 검사합니다. 최종 통관 가부는 통관사 확인 사항입니다.";

/** Decode a base64 string to bytes (browser + Node safe). */
function base64ToBytes(b64: string): Uint8Array {
  if (typeof atob === "function") {
    const bin = atob(b64);
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
  }
  // Node
  return new Uint8Array(Buffer.from(b64, "base64"));
}

/**
 * The blank CI+PL template bytes (xlsx). Same form as the original — logo,
 * signature/seal image, styles, merged cells preserved — with customer data
 * cleared. The merge engine loads this and injects deal values.
 */
export function blankTemplateBytes(): Uint8Array {
  return base64ToBytes(TEMPLATE_BASE64);
}
